// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"c73ef160d676e574b865","678":"0150ad6d49d6172285ee"}[chunkId] + ".js";
};